import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";
import { Button } from "@/v2/components/ui/button";
import type { DatePickerSlotProps } from "./DatePicker";

export function DatePickerDefaultFooter({
	selectDate,
	selectRange,
}: DatePickerSlotProps) {
	const now = new Date();

	return (
		<div className="border-t border-border grid grid-cols-3">
			<Button
				variant="ghost"
				className="rounded-none h-9 text-xs text-primary"
				onClick={() => selectDate(now)}
			>
				Today
			</Button>
			<Button
				variant="ghost"
				className="rounded-none h-9 text-xs text-primary border-l border-border"
				onClick={() =>
					selectRange({ from: startOfWeek(now), to: endOfWeek(now) })
				}
			>
				This week
			</Button>
			<Button
				variant="ghost"
				className="rounded-none h-9 text-xs text-primary border-l border-border"
				onClick={() =>
					selectRange({ from: startOfMonth(now), to: endOfMonth(now) })
				}
			>
				This month
			</Button>
		</div>
	);
}
